import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateHelper } from '@app/_helpers';
import { DirectionService } from '@app/_services/direction.service';
import { TranslateService } from '@ngx-translate/core';
import { NgFor } from '@angular/common';

@Component({
    selector: 'app-block-mini-feature-cards',
    templateUrl: './block-mini-feature-cards.component.html',
    styleUrls: ['./block-mini-feature-cards.component.scss'],
    standalone: true,
    imports: [NgFor]
})
export class BlockMiniFeatureCardsComponent {
    @Input() cards = [];



    constructor(
        public sanitizer: DomSanitizer,
        private direction: DirectionService,
        public translateHelper: TranslateHelper,
        public translate: TranslateService,
    ) { }
}

